import { Routes } from '../../config/routes';
import FaceAuthStep from '../../providers/validation/steps/FaceAuthStep';
import { Screens } from '../../services/analytics/screens';
import withRouteAnalytics from '../../services/analytics/withRouteAnalytics';
import GenericFaceAuthScreen from './GenericFaceAuthScreen';

function DocumentSelfieScreen(): JSX.Element {
  return (
    <GenericFaceAuthScreen
      route={Routes.DOCUMENT_SELFIE}
      getStepWorker={(userDid: string) => new FaceAuthStep(userDid, true)}
    />
  );
}
export default withRouteAnalytics(DocumentSelfieScreen, Screens.DOCUMENT_SELFIE_CAPTURE);
